(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wow-board-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const initPicker = (root) => {
      if (root.wowBoardPicker) return;
      const form = root.closest('form');
      const canonical = root.querySelector('[data-product-display-field]');
      const enhanced = root.querySelector('[data-picker-enhanced]');
      const control = root.querySelector('[data-picker-control]');
      const trigger = root.querySelector('[data-picker-trigger]');
      const summary = root.querySelector('[data-picker-summary]');
      const popover = root.querySelector('[data-picker-popover]');
      const unsure = root.querySelector('[data-picker-unsure]');
      const chips = root.querySelector('[data-picker-chips]');
      const status = root.querySelector('[data-picker-status]');
      const error = root.querySelector('[data-picker-error]');
      const context = root.querySelector('[data-picker-context]');
      const dialog = root.querySelector('[data-picker-dialog]');
      const dialogImage = root.querySelector('[data-picker-dialog-image]');
      const previewPhoto = root.querySelector('[data-picker-preview-photo]');
      const desktopPreview = window.matchMedia('(min-width: 761px) and (hover: hover)');
      const options = Array.from(root.querySelectorAll('[data-picker-option]'));
      const byHandle = new Map(options.map((option) => [option.dataset.handle, option]));
      let selected = [];
      let modalOpener = null;
      let previewedOption = null;

      if (!form || !canonical || !enhanced || !trigger || !popover || !unsure || !dialog) return;

      const clearError = () => {
        error.hidden = true;
        error.textContent = '';
        trigger.removeAttribute('aria-invalid');
      };

      const positionPopover = () => {
        if (popover.hidden) return;
        popover.style.left = '0px';
        const anchor = control.getBoundingClientRect();
        const below = window.innerHeight - anchor.bottom - 20;
        const above = anchor.top - 20;
        const upwards = below < 280 && above > below;
        popover.classList.toggle('is-upwards', upwards);
        popover.style.setProperty('--picker-list-height', `${Math.max(140, Math.min(365, (upwards ? above : below) - 130))}px`);
        const box = popover.getBoundingClientRect();
        const offset = Math.max(16 - anchor.left, Math.min(0, window.innerWidth - 16 - box.right));
        popover.style.left = `${offset}px`;
      };

      const previewOption = (option) => {
        if (!desktopPreview.matches || !option || !option.dataset.largeImage) return;
        const image = root.querySelector('[data-picker-preview-image]');
        if (image.getAttribute('src') !== option.dataset.largeImage) image.src = option.dataset.largeImage;
        image.alt = option.dataset.imageAlt || option.dataset.title;
        previewedOption = option;
        previewPhoto.hidden = false;
        previewPhoto.setAttribute('aria-label', root.dataset.enlargeLabel.replace('__board__', option.dataset.title));
        previewPhoto.dataset.wowProduct = option.dataset.handle;
        root.querySelector('[data-picker-preview-name]').textContent = option.dataset.title;
        root.querySelector('[data-picker-preview-price]').textContent = option.querySelector('[data-picker-price]').textContent;
      };

      const openPhoto = (option, opener) => {
        if (!option?.dataset.largeImage || dialog.open) return;
        modalOpener = opener;
        dialogImage.src = option.dataset.largeImage;
        dialogImage.alt = option.dataset.imageAlt || option.dataset.title;
        root.querySelector('[data-picker-dialog-title]').textContent = option.dataset.title;
        root.querySelector('[data-picker-dialog-collection]').textContent = option.dataset.collectionTitle;
        root.querySelector('[data-picker-dialog-price]').textContent = option.querySelector('[data-picker-price]').textContent;
        const details = root.querySelector('[data-picker-dialog-details]');
        const template = option.querySelector('[data-picker-details]');
        details.replaceChildren();
        if (template) details.append(template.content.cloneNode(true));
        dialog.showModal();
        dialog.scrollTop = 0;
        root.querySelector('[data-picker-dialog-copy]')?.scrollTo(0, 0);
      };

      const setOpen = (open, focusFirst = false) => {
        popover.hidden = !open;
        trigger.setAttribute('aria-expanded', String(open));
        if (open) {
          positionPopover();
          previewOption(selected[0] || options[0]);
          if (focusFirst) (selected[0]?.querySelector('[data-picker-checkbox]') || unsure).focus();
        }
      };

      const sync = () => {
        const hasUnsure = unsure.checked;
        canonical.value = hasUnsure ? root.dataset.unsureValue : selected.map((option) => option.dataset.title).join('; ');
        const productField = form.querySelector('[data-product-field]');
        const collectionField = form.querySelector('[data-collection-field]');
        if (productField) productField.value = hasUnsure ? '' : selected.map((option) => option.dataset.handle).join(',');
        if (collectionField) collectionField.value = hasUnsure ? '' : Array.from(new Set(selected.map((option) => option.dataset.collection))).join(',');
        summary.textContent = hasUnsure ? root.dataset.unsureLabel : selected.length === 2 ? root.dataset.twoLabel : selected.length === 1 ? root.dataset.oneLabel : root.dataset.emptyLabel;
        options.forEach((option) => {
          const checked = selected.includes(option);
          option.querySelector('[data-picker-checkbox]').checked = checked;
          option.classList.toggle('is-selected', checked);
        });
        chips.replaceChildren();
        selected.forEach((option) => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'wow-board-picker__chip';
          chip.setAttribute('aria-label', root.dataset.removeLabel.replace('__board__', option.dataset.title));
          chip.dataset.wowEvent = 'board_choice_remove';
          chip.dataset.wowLocation = 'request_board_chip';
          chip.dataset.wowProduct = option.dataset.handle;
          const name = document.createElement('span');
          name.textContent = option.dataset.title;
          const cross = document.createElement('span');
          cross.textContent = '×';
          cross.setAttribute('aria-hidden', 'true');
          chip.append(name, cross);
          chip.addEventListener('click', () => {
            selected = selected.filter((entry) => entry !== option);
            clearError();
            sync();
            trigger.focus({ preventScroll: true });
          });
          chips.append(chip);
        });
        status.textContent = selected.length === 2 ? root.dataset.limitMessage : root.dataset.defaultMessage;
        canonical.dispatchEvent(new Event('input', { bubbles: true }));
        canonical.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const reset = () => {
        selected = [];
        unsure.checked = false;
        clearError();
        context.hidden = true;
        context.textContent = '';
        setOpen(false);
        if (dialog.open) dialog.close();
        sync();
      };

      const validate = () => {
        sync();
        if (unsure.checked || selected.length > 0 && selected.length <= 2) {
          clearError();
          return true;
        }
        error.textContent = root.dataset.requiredMessage;
        error.hidden = false;
        trigger.setAttribute('aria-invalid', 'true');
        setOpen(true);
        trigger.focus();
        return false;
      };

      trigger.addEventListener('click', (event) => setOpen(popover.hidden, event.detail === 0));
      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setOpen(true, true);
        }
      });
      root.querySelector('[data-picker-done]').addEventListener('click', () => {
        setOpen(false);
        trigger.focus({ preventScroll: true });
      });
      unsure.addEventListener('change', () => {
        if (unsure.checked) selected = [];
        clearError();
        sync();
      });
      options.forEach((option) => {
        const checkbox = option.querySelector('[data-picker-checkbox]');
        checkbox.addEventListener('change', () => {
          if (checkbox.checked && selected.length === 2) {
            checkbox.checked = false;
            status.textContent = root.dataset.limitMessage;
            return;
          }
          if (checkbox.checked) {
            unsure.checked = false;
            selected.push(option);
          } else {
            selected = selected.filter((entry) => entry !== option);
          }
          clearError();
          sync();
        });
        option.addEventListener('pointerenter', () => previewOption(option));
        option.addEventListener('focusin', () => previewOption(option));
        const photo = option.querySelector('[data-picker-photo]');
        if (photo) photo.addEventListener('click', () => openPhoto(option, photo));
      });
      previewPhoto.addEventListener('click', () => openPhoto(previewedOption, previewPhoto));
      root.querySelector('[data-picker-dialog-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (modalOpener?.isConnected) modalOpener.focus({ preventScroll: true });
        modalOpener = null;
      });
      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !dialog.open && !popover.hidden) {
          event.preventDefault();
          setOpen(false);
          trigger.focus({ preventScroll: true });
        }
      });
      document.addEventListener('pointerdown', (event) => {
        if (!root.contains(event.target) && !dialog.open) setOpen(false);
      });
      root.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !root.contains(event.relatedTarget) && !dialog.open) setOpen(false);
      });
      window.addEventListener('resize', positionPopover);
      form.addEventListener('reset', () => queueMicrotask(reset));

      const params = new URLSearchParams(window.location.search);
      selected = Array.from(new Set((params.get('product') || '').split(',').map((handle) => handle.trim())))
        .map((handle) => byHandle.get(handle)).filter(Boolean).slice(0, 2);
      const collectionHandle = params.get('collection');
      const group = Array.from(root.querySelectorAll('[data-picker-group]')).find((entry) => entry.dataset.collection === collectionHandle);
      if (!selected.length && group) {
        context.textContent = root.dataset.contextMessage.replace('__collection__', group.dataset.collectionTitle);
        context.hidden = false;
      }
      canonical.type = 'hidden';
      canonical.required = false;
      enhanced.hidden = false;
      root.classList.add('is-enhanced');
      root.wowBoardPicker = { validate, reset, sync };
      sync();
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-wow-board-picker]')) initPicker(scope);
      scope.querySelectorAll('[data-wow-board-picker]').forEach(initPicker);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wow-consent-banner"] && !Shopify.designMode) return;
  try {
    (() => {
      const root = document.querySelector('[data-wow-consent-root]');
      if (!root || root.dataset.initialized === 'true') return;

      root.dataset.initialized = 'true';

      const banner = root.querySelector('[data-wow-consent-banner]');
      const dialog = root.querySelector('[data-wow-consent-dialog]');
      const saleDialog = root.querySelector('[data-wow-consent-sale-dialog]');
      const saleOptOutButton = root.querySelector('[data-wow-consent-action="sale-opt-out"]');
      const saleOpenButtons = document.querySelectorAll('[data-wow-consent-sale-open]');
      const statusNodes = root.querySelectorAll('[data-wow-consent-status]');
      const errorMessage = root.querySelector('[data-wow-consent-error]').textContent.trim();
      const savingMessage = root.querySelector('[data-wow-consent-saving]').textContent.trim();
      const savedMessage = root.querySelector('[data-wow-consent-saved]').textContent.trim();
      const saleSavedMessage = root.querySelector('[data-wow-consent-sale-saved]').textContent.trim();
      const saleCurrentMessage = root.querySelector('[data-wow-consent-sale-current]').textContent.trim();
      const showGlobally = root.dataset.showGlobally === 'true';
      const policyVersion = root.dataset.policyVersion || '2026-07-20';
      let privacyApi = null;
      let bannerWasVisible = false;
      let saleBannerWasVisible = false;

      const getFocusableElements = (activeDialog) =>
        Array.from(
          activeDialog.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter((element) => !element.hidden && element.getClientRects().length > 0);

      const focusFirstDialogControl = (activeDialog) => {
        const [firstControl] = getFocusableElements(activeDialog);
        if (firstControl) firstControl.focus();
      };

      const keepFocusInOpenDialog = (event) => {
        if (event.key !== 'Tab') return;

        const activeDialog = dialog.open ? dialog : saleDialog.open ? saleDialog : null;
        if (!activeDialog) return;

        const controls = getFocusableElements(activeDialog);
        if (!controls.length) return;

        const firstControl = controls[0];
        const lastControl = controls[controls.length - 1];

        if (!activeDialog.contains(document.activeElement)) {
          event.preventDefault();
          (event.shiftKey ? lastControl : firstControl).focus();
          return;
        }

        if (event.shiftKey && document.activeElement === firstControl) {
          event.preventDefault();
          lastControl.focus();
        } else if (!event.shiftKey && document.activeElement === lastControl) {
          event.preventDefault();
          firstControl.focus();
        }
      };

      const categoryInputs = {
        preferences: root.querySelector('[data-wow-consent-category="preferences"]'),
        analytics: root.querySelector('[data-wow-consent-category="analytics"]'),
        marketing: root.querySelector('[data-wow-consent-category="marketing"]')
      };

      const setStatus = (message) => {
        statusNodes.forEach((node) => {
          node.textContent = message;
          node.hidden = !message;
        });
      };

      const setBusy = (busy) => {
        root.querySelectorAll('[data-wow-consent-action="accept"], [data-wow-consent-action="reject"], [data-wow-consent-action="save"], [data-wow-consent-action="sale-opt-out"]').forEach((button) => {
          button.disabled = busy;
        });
      };

      const getConsent = () => {
        if (!privacyApi) return {};

        try {
          return privacyApi.currentVisitorConsent() || {};
        } catch (error) {
          return {};
        }
      };

      const hasCookieDecision = (consent) =>
        ['preferences', 'analytics', 'marketing'].some(
          (category) => consent[category] === 'yes' || consent[category] === 'no'
        );

      const saleRegion = () => {
        if (!privacyApi) return false;

        try {
          return Boolean(privacyApi.saleOfDataRegion());
        } catch (error) {
          return false;
        }
      };

      const populateChoices = () => {
        const consent = getConsent();
        categoryInputs.preferences.checked = consent.preferences === 'yes';
        categoryInputs.analytics.checked = consent.analytics === 'yes';
        categoryInputs.marketing.checked = consent.marketing === 'yes';
      };

      const updateSaleControls = () => {
        const available = saleRegion();
        saleOpenButtons.forEach((button) => {
          button.hidden = !available;
        });
      };

      const categoryExplicitlyAllowed = (category, consent) =>
        category === 'essential' || consent[category] === 'yes';

      const refreshManualContent = () => {
        const consent = getConsent();

        document.querySelectorAll('script[type="text/plain"][data-wow-consent-category]').forEach((source) => {
          const category = source.dataset.wowConsentCategory;
          if (!categoryExplicitlyAllowed(category, consent) || source.dataset.wowConsentActivated === 'true') return;

          const runtime = document.createElement('script');
          Array.from(source.attributes).forEach((attribute) => {
            if (!['type', 'data-src', 'data-wow-consent-category', 'data-wow-consent-activated'].includes(attribute.name)) {
              runtime.setAttribute(attribute.name, attribute.value);
            }
          });

          if (source.dataset.src) runtime.src = source.dataset.src;
          runtime.dataset.wowConsentRuntime = category;
          runtime.textContent = source.textContent;
          source.dataset.wowConsentActivated = 'true';
          source.after(runtime);
        });

        document.querySelectorAll('iframe[data-wow-consent-category][data-src]').forEach((frame) => {
          const allowed = categoryExplicitlyAllowed(frame.dataset.wowConsentCategory, consent);
          if (allowed && !frame.getAttribute('src')) frame.setAttribute('src', frame.dataset.src);
          if (!allowed && frame.getAttribute('src')) frame.removeAttribute('src');
        });
      };

      const announceConsent = () => {
        const consent = getConsent();
        document.dispatchEvent(new CustomEvent('wow:consent-updated', { detail: consent }));
      };

      const shouldReloadForWithdrawal = (payload) => {
        const before = getConsent();
        return ['preferences', 'analytics', 'marketing'].some(
          (category) => before[category] === 'yes' && payload[category] === false
        );
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function' && dialog.open) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }

        if (bannerWasVisible) banner.hidden = false;
      };

      const openDialog = () => {
        bannerWasVisible = !banner.hidden;
        banner.hidden = true;
        populateChoices();
        setStatus('');

        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }

        focusFirstDialogControl(dialog);
      };

      const closeSaleDialog = () => {
        if (typeof saleDialog.close === 'function' && saleDialog.open) {
          saleDialog.close();
        } else {
          saleDialog.removeAttribute('open');
        }

        if (saleBannerWasVisible) banner.hidden = false;
      };

      const openSaleDialog = () => {
        saleBannerWasVisible = !banner.hidden;
        banner.hidden = true;
        const alreadyOptedOut = getConsent().sale_of_data === 'no';
        saleOptOutButton.disabled = alreadyOptedOut;
        setStatus(alreadyOptedOut ? saleCurrentMessage : '');

        if (typeof saleDialog.showModal === 'function') {
          if (!saleDialog.open) saleDialog.showModal();
        } else {
          saleDialog.setAttribute('open', '');
        }

        focusFirstDialogControl(saleDialog);
      };

      const completeConsent = (reload) => {
        bannerWasVisible = false;
        banner.hidden = true;
        setBusy(false);
        setStatus(savedMessage);
        refreshManualContent();
        announceConsent();

        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        if (reload) window.location.reload();
      };

      const saveConsent = (payload) => {
        if (!privacyApi) {
          setStatus(errorMessage);
          return;
        }

        const reload = shouldReloadForWithdrawal(payload);
        payload.metafields = [{ key: 'wow-consent-v', value: policyVersion }];
        setBusy(true);
        setStatus(savingMessage);

        privacyApi.setTrackingConsent(payload, (error) => {
          if (error) {
            setBusy(false);
            setStatus(errorMessage);
            return;
          }

          completeConsent(reload);
        });
      };

      const saveCustomChoices = () => {
        const payload = {
          preferences: categoryInputs.preferences.checked,
          analytics: categoryInputs.analytics.checked,
          marketing: categoryInputs.marketing.checked
        };

        saveConsent(payload);
      };

      const saveSaleOptOut = () => {
        if (!privacyApi) {
          setStatus(errorMessage);
          return;
        }

        setBusy(true);
        setStatus(savingMessage);

        privacyApi.setTrackingConsent(
          {
            sale_of_data: false,
            metafields: [{ key: 'wow-consent-v', value: policyVersion }]
          },
          (error) => {
            setBusy(false);
            if (error) {
              setStatus(errorMessage);
              return;
            }

            saleOptOutButton.disabled = true;
            setStatus(saleSavedMessage);
            announceConsent();
          }
        );
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-wow-consent-action]');
        if (!button) return;

        const action = button.dataset.wowConsentAction;
        if (action === 'accept') {
          saveConsent({ preferences: true, analytics: true, marketing: true });
        } else if (action === 'reject') {
          saveConsent({ preferences: false, analytics: false, marketing: false });
        } else if (action === 'customize') {
          openDialog();
        } else if (action === 'save') {
          saveCustomChoices();
        } else if (action === 'close') {
          closeDialog();
        } else if (action === 'sale-opt-out') {
          saveSaleOptOut();
        } else if (action === 'sale-close') {
          closeSaleDialog();
        }
      });

      document.querySelectorAll('[data-wow-consent-open]').forEach((button) => {
        button.addEventListener('click', openDialog);
      });

      saleOpenButtons.forEach((button) => {
        button.addEventListener('click', openSaleDialog);
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog();
      });

      saleDialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeSaleDialog();
      });

      document.addEventListener('keydown', keepFocusInOpenDialog);

      document.addEventListener('visitorConsentCollected', () => {
        const consent = getConsent();
        if (hasCookieDecision(consent)) banner.hidden = true;
        populateChoices();
        updateSaleControls();
        refreshManualContent();
        announceConsent();
      });

      const initialize = () => {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
          banner.hidden = false;
          setStatus(errorMessage);
          return;
        }

        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          (error) => {
            if (error || !window.Shopify.customerPrivacy) {
              banner.hidden = false;
              setStatus(errorMessage);
              return;
            }

            privacyApi = window.Shopify.customerPrivacy;
            const consent = getConsent();
            let apiRequestsBanner = false;

            try {
              apiRequestsBanner = Boolean(privacyApi.shouldShowBanner());
            } catch (privacyError) {
              apiRequestsBanner = false;
            }

            populateChoices();
            updateSaleControls();
            refreshManualContent();
            banner.hidden = !(apiRequestsBanner || (showGlobally && !hasCookieDecision(consent)));
          }
        );
      };

      initialize();
    })();
  } catch(e) { console.error(e); }
})();

})();
